import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RoutesConfig, UserProfiles } from "./types";
import { fetchAuthSession } from "aws-amplify/auth";

interface ProtectedRouteProps {
  children: React.ReactElement;
  allowedProfiles?: readonly UserProfiles[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedProfiles,
}) => {
  const [userRole, setUserRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [sessionValid, setSessionValid] = useState<boolean>(true);
  const location = useLocation();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken;

        if (!idToken) {
          setSessionValid(false);
          return;
        }

        const exp = idToken.payload?.exp;
        const now = Math.floor(Date.now() / 1000);

        if (!exp || exp < now) {
          console.warn("Token expirado");
          setSessionValid(false);
          return;
        }

        const groups = session.tokens?.idToken?.payload?.["cognito:groups"] as
          | string[]
          | undefined;
        setUserRole(groups?.[0] || null);
      } catch (error) {
        console.error("Erro ao buscar dados do usuário:", error);
        setUserRole(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (loading) return null;

  if (
    !sessionValid ||
    !userRole ||
    (allowedProfiles && !allowedProfiles.includes(userRole as UserProfiles))
  ) {
    return (
      <Navigate
        to={RoutesConfig.LOGIN.path}
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};
